import { cn } from '@/shared/lib/cn';
import { axisPercent, type LaneSegment } from './heuteDayModel';

const SEGMENT_TONE: Record<LaneSegment['type'], string> = {
  out: 'bg-ink-soft/15 text-ink',
  clean: 'bg-amber-tint text-ink',
  in: 'bg-forest text-white',
};

/** Die Spur einer Bahn: Abreise, Reinigung, Anreise auf der Tagesachse, am heutigen Tag mit Jetzt-Linie. */
export function HeuteLaneTrack({
  segments,
  nowMinutes,
}: {
  segments: LaneSegment[];
  nowMinutes: number | null;
}) {
  return (
    <span className="bg-paper rounded-square relative h-10">
      {segments.map((segment, index) => (
        <span
          key={index}
          className={cn(
            'rounded-square absolute inset-y-1 flex items-center overflow-hidden px-2 text-[11px] font-bold',
            SEGMENT_TONE[segment.type],
          )}
          style={{ left: `${segment.left}%`, width: `${segment.width}%` }}
        >
          <span className="truncate">{segment.label}</span>
        </span>
      ))}
      {nowMinutes !== null && (
        <span
          aria-hidden
          data-testid="now-line"
          className="bg-sealwax absolute inset-y-0 w-0.5"
          style={{ left: `${axisPercent(nowMinutes)}%` }}
        />
      )}
    </span>
  );
}
